import login, { LoginReducer } from './login';
import { combineReducers } from 'redux';

export type Reducer = {
  login: LoginReducer;
};

export default combineReducers({ login });
